import ApiService from '@/services/api';
import { EntityBuilder } from '@decahedron/entity';
import Property from '@/entities/Property';
import CarOption from '@/entities/CarOption';

let instance: PropertyService = null;

export default class PropertyService {
  apiService: ApiService = null;

  constructor() {
    if (!instance) {
      this.apiService = new ApiService();
      instance = this;
    }

    return instance;
  }

  list(propertyType: string) {
    return this.apiService
      .get(propertyType)
      .then((response) => this.build(propertyType, response, true));
  }

  build(propertyType: string, response: any, many = false) {
    if (propertyType === 'options') {
      return many
        ? EntityBuilder.buildMany<CarOption>(CarOption, response.data)
        : EntityBuilder.buildOne(CarOption, response.data);
    }

    return many
      ? EntityBuilder.buildMany<Property>(Property, response.data)
      : EntityBuilder.buildOne(Property, response.data);
  }

  save(propertyType: string, property: any) {
    if (property.id) {
      return this.apiService
        .put(`${propertyType}/${property.id}`, property.toJson())
        .then((response) => this.build(propertyType, response));
    }

    return this.apiService
      .post(propertyType, property.toJson())
      .then((response) => this.build(propertyType, response));
  }

  delete(propertyType: string, property: any) {
    return this.apiService.delete(`${propertyType}/${property.id}`);
  }

  saveOrder(cars: CarOption[]) {
    return this.apiService.put('options/position', cars.map((car: CarOption) => {
      const carCopy = car;
      return {
        id: carCopy.id,
        position: carCopy.position,
      };
    }));
  }
}
